import { OBaseModel } from '@olameter/o-utilities';

export class AuditModel implements OBaseModel {
  name: string;
  fieldName: string;
  oldValue: string;
  newValue: string;
}
